import { useCallback, useReducer } from "react";

const actionTypes = {
  show_confirm: "show_confirm",
  close_confirm: "close_confirm",
};

const confirmReducer = (confirm, action) => {
  switch (action.type) {
    case actionTypes.show_confirm: {
      return {
        open: true,
        title: action.title,
        message: action.message,
        confirmButtonText: action.confirmButtonText,
        callbacks: action.callbacks,
        declineButtonText: action.declineButtonText,
      };
    }
    case actionTypes.close_confirm: {
      return { ...confirm, open: false };
    }
    default: {
      throw new Error(`Unhandled type in confirmReducer: ${action.type}`);
    }
  }
};

const useConfirm = ({ reducer = confirmReducer } = {}) => {
  const [confirm, dispatch] = useReducer(reducer, {
    open: false,
    title: "",
    message: "",
    confirmButtonText: "",
    callbacks: {},
    declineButtonText: "",
  });

  const showConfirm = useCallback(
    (
      title,
      message,
      callbacks = {},
      confirmButtonText = "Discard",
      declineButtonText = "Cancel",
    ) => {
      dispatch({
        type: actionTypes.show_confirm,
        title,
        message,
        confirmButtonText,
        callbacks,
        declineButtonText,
      });
    },
    [],
  );

  const cancelConfirm = useCallback(
    event => {
      event.stopPropagation();
      dispatch({
        type: actionTypes.close_confirm,
      });
      confirm.callbacks.onCancel && confirm.callbacks.onCancel();
    },
    [confirm.callbacks],
  );

  const closeConfirm = useCallback(
    onConfirm => {
      dispatch({
        type: actionTypes.close_confirm,
      });
      confirm.callbacks.onConfirm && confirm.callbacks.onConfirm();
    },
    [confirm.callbacks],
  );

  return { confirm, cancelConfirm, closeConfirm, showConfirm };
};

export { useConfirm, actionTypes };
